const RUTAS_CAMBIOS_FORMULARIOS = [
  // Detalles entidades
  'notification/new',
  'notification/details',
  'presentation/new',
  'companies/detail',
  'companies/hotfolder',
  'certificates/detail',
  'certificates/replace',
  'configurations/distributors/details',
  'configurations/clients/details',
  'configurations/users/details',
  'configurations/groups/details',
  'configurations/rules/details',
  'configurations/configflow/details',
  'configurations/orgprovinces/details',
  'configurations/apirequests/details',
  'procedings/details',

  // Detalles papelera NO NECESARIO, no se hacen cambios en estas vistas
  // 'trash/notifications/details',
  // 'trash/companies/details',
  // 'trash/users/details',
  // 'trash/groups/details',
  
  // Plantillas
  'configurations/template/companies',
  'configurations/clients/template/companies',
  'configurations/template/groups',
  'configurations/clients/template/groups',
  'configurations/template/clients',
  'configurations/distributors/template/clients',
  'configurations/template/clientspersonalization',
  'configurations/distributors/template/clientspersonalization',
  'configurations/template/clientsdownloadschedule',
  'configurations/distributors/template/clientsdownloadschedule',
  'configurations/template/clientsholidaycalendar',
  'configurations/distributors/template/clientsholidaycalendar',
  
  // Otros
  'configurations/general',
  'configurations/representative',
  'configurations/clients/representative',
  'configurations/users/profile',
  'configurations/clients/modules',
  'configurations/distributors/modules',
  'configurations/personalization',
  'configurations/clients/personalization',
  'configurations/downloadschedule',
  'configurations/clients/downloadschedule',
  'configurations/holidaycalendar',
  'configurations/clients/holidaycalendar',
  'configurations/configaiassist',
  'configurations/clients/configaiassist',
]

export {
  RUTAS_CAMBIOS_FORMULARIOS
}
